import { Brand } from '../brand';

export interface FileUploadOption {
  name: string;
  titleKey: string;
}

export const BRAND_FILE_UPLOAD_OPTIONS: Record<Brand, FileUploadOption[]> = {
  [Brand.DEFAULT]: [
    { name: 'referralFromGynecologist', titleKey: 'referralFromGynecologist' },
    { name: 'referralFromUrologist', titleKey: 'referralFromUrologist' },
    { name: 'bloodTestHormoneAnalysis', titleKey: 'bloodTestHormoneAnalysis' },
    { name: 'bloodTestSerology', titleKey: 'bloodTestSerology' },
    { name: 'ultrasound', titleKey: 'ultrasound' },
    { name: 'previousOperationsStomach', titleKey: 'previousOperationsStomach' },
    { name: 'previousFertilityTreatments', titleKey: 'previousFertilityTreatments' },
    { name: 'psychotherapeuticTreatment', titleKey: 'psychotherapeuticTreatment' },
    { name: 'fallopianTubePatencyTest', titleKey: 'fallopianTubePatencyTest' },
    { name: 'laparoscopy', titleKey: 'laparoscopy' },
    { name: 'uterineEndoscopy', titleKey: 'uterineEndoscopy' },
    { name: 'chromosomeAnalysis', titleKey: 'chromosomeAnalysis' },
    { name: 'miscarriage', titleKey: 'miscarriage' },
    { name: 'spermAnalysis', titleKey: 'spermAnalysis' },
    { name: 'cycleLogs', titleKey: 'cycleLogs' },
    { name: 'otherFindings', titleKey: 'otherFindings' },
  ],
  [Brand.FERTILLY_COM]: [
    { name: 'referralFromGynecologist', titleKey: 'referralFromGynecologist' },
    { name: 'referralFromUrologist', titleKey: 'referralFromUrologist' },
    { name: 'bloodTestHormoneAnalysis', titleKey: 'bloodTestHormoneAnalysis' },
    { name: 'bloodTestSerology', titleKey: 'bloodTestSerology' },
    { name: 'ultrasound', titleKey: 'ultrasound' },
    { name: 'previousOperationsStomach', titleKey: 'previousOperationsStomach' },
    { name: 'previousFertilityTreatments', titleKey: 'previousFertilityTreatments' },
    { name: 'psychotherapeuticTreatment', titleKey: 'psychotherapeuticTreatment' },
    { name: 'fallopianTubePatencyTest', titleKey: 'fallopianTubePatencyTest' },
    { name: 'laparoscopy', titleKey: 'laparoscopy' },
    { name: 'uterineEndoscopy', titleKey: 'uterineEndoscopy' },
    { name: 'chromosomeAnalysis', titleKey: 'chromosomeAnalysis' },
    { name: 'miscarriage', titleKey: 'miscarriage' },
    { name: 'spermAnalysis', titleKey: 'spermAnalysis' },
    { name: 'cycleLogs', titleKey: 'cycleLogs' },
    { name: 'otherFindings', titleKey: 'otherFindings' },
  ],
  [Brand.KLINIK_AM_SCHLOSSPARK_DE]: [
    { name: 'labResults', titleKey: 'labResults' },
    { name: 'spermAnalysis', titleKey: 'spermAnalysis' },
    { name: 'medicalConsent', titleKey: 'medicalConsent' },
    { name: 'treatmentPlan', titleKey: 'treatmentPlan' },
    { name: 'prescriptions', titleKey: 'prescriptions' },
    { name: 'medicationAnesthesia', titleKey: 'medicationAnesthesia' },
    { name: 'punctureFindings', titleKey: 'punctureFindings' },
    { name: 'transferFindings', titleKey: 'transferFindings' },
    { name: 'relocationDocuments', titleKey: 'relocationDocuments' },
    { name: 'otherFindings', titleKey: 'otherFindings' },
  ],
};
